import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Quote } from 'lucide-react';
import { Stars } from './reviewParts';
import { formatDate } from '../../lib/dateUtils';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PublicReviews = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}/reviews/public`).then((res) => setReviews(res.data)).catch(() => setReviews([]));
  }, []);

  if (reviews.length === 0) return null;
  const avg = (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1);

  return (
    <section className="container mx-auto px-4 pb-12 max-w-6xl" data-testid="public-reviews-section">
      <div className="text-center mb-8">
        <h2 className="text-2xl sm:text-3xl font-bold">What our users say</h2>
        <p className="text-sm text-muted-foreground mt-1" data-testid="public-reviews-average">
          {avg} out of 5 from {reviews.length} review{reviews.length > 1 ? 's' : ''}
        </p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {reviews.map((r) => (
          <figure key={r.review_id} className="bg-white border rounded-2xl p-5 shadow-sm flex flex-col gap-3" data-testid={`public-review-${r.review_id}`}>
            <div className="flex items-center justify-between">
              <Stars value={r.rating} size="w-4 h-4" />
              <Quote className="w-5 h-5 text-emerald-200" />
            </div>
            <blockquote className="text-sm text-foreground flex-1">{r.message}</blockquote>
            <figcaption className="text-sm">
              <span className="font-semibold" data-testid={`public-review-name-${r.review_id}`}>{r.first_name}</span>
              <span className="text-muted-foreground"> · {r.role}</span>
              {r.published_at && <span className="block text-xs text-muted-foreground">{formatDate(r.published_at)}</span>}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};
